import _defineProperty from "@babel/runtime/helpers/defineProperty";
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import { css } from '@emotion/react';
import { BodiedSyncBlockSharedCssClassName, SyncBlockSharedCssClassName, SyncBlockLabelSharedCssClassName } from '@atlaskit/editor-common/sync-block';
import { akEditorGutterPadding } from '@atlaskit/editor-shared-styles';
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var syncBlockStyles = css(_defineProperty(_defineProperty(_defineProperty({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.ProseMirror': _defineProperty({}, ".".concat(SyncBlockSharedCssClassName.prefix, ", .").concat(BodiedSyncBlockSharedCssClassName.prefix), _defineProperty(_defineProperty({
    position: 'relative',
    cursor: 'pointer',
    /* Danger when top level node */
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '&.danger': _defineProperty({
      boxShadow: "0 0 0 1px ".concat("var(--ds-border-danger, #E2483D)"),
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
      backgroundColor: "var(--ds-background-danger, #FFECEB)".concat(" !important"),
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '.ak-editor-panel__icon': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-important-styles
        color: "var(--ds-icon-danger, #C9372C)".concat(" !important")
      }
    }, ".".concat(SyncBlockLabelSharedCssClassName.labelClassName), {
      color: "var(--ds-icon-danger, #C9372C)",
      backgroundColor: "var(--ds-background-danger-hovered, #FFD5D2)"
    }),
    borderRadius: "var(--ds-radius-small, 3px)",
    marginTop: "var(--ds-space-150, 12px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    marginRight: "-".concat(akEditorGutterPadding, "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    marginLeft: "-".concat(akEditorGutterPadding, "px"),
    marginBottom: 0,
    paddingTop: "var(--ds-space-050, 4px)",
    paddingBottom: "var(--ds-space-050, 4px)",
    color: 'inherit',
    '&:hover': {
      // eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
      boxShadow: "0px 0px 0px 1px ".concat("var(--ds-border-accent-purple, #8270DB)")
    }
  }, ".".concat(BodiedSyncBlockSharedCssClassName.content), {
    padding: '0 32px',
    cursor: 'text'
  }), ".".concat(SyncBlockSharedCssClassName.renderer), {
    padding: '0 32px'
  }))
}, ".".concat(SyncBlockSharedCssClassName.prefix, ".ak-editor-selected-node:not(.danger), .").concat(BodiedSyncBlockSharedCssClassName.prefix, ".ak-editor-selected-node:not(.danger)"), {
  boxShadow: "0 0 0 1px ".concat("var(--ds-border-accent-purple, #8270DB)")
}), ".".concat(SyncBlockSharedCssClassName.prefix, ".ak-editor-selected-node, .").concat(BodiedSyncBlockSharedCssClassName.prefix, ".ak-editor-selected-node"), _defineProperty({}, ".".concat(SyncBlockLabelSharedCssClassName.labelClassName), {
  display: 'unset'
})), ".".concat(SyncBlockLabelSharedCssClassName.labelClassName), {
  color: "var(--ds-text-accent-purple, #5E4DB2)",
  borderRadius: "var(--ds-radius-small, 3px)",
  position: 'absolute',
  display: 'none',
  paddingLeft: "var(--ds-space-100, 8px)",
  paddingRight: "var(--ds-space-100, 8px)",
  paddingBottom: "var(--ds-space-050, 4px)",
  paddingTop: "var(--ds-space-050, 4px)",
  // height of label (32px) + space between sync block and label (4px) = 36px
  top: '-36px',
  right: '0px',
  backgroundColor: "var(--ds-background-accent-purple-subtlest, #F3F0FF)"
}));